import {
  FaFacebookF,
  FaLinkedinIn,
  FaMapMarkerAlt,
  FaPhoneAlt,
} from "react-icons/fa";
import { TiSocialYoutube } from "react-icons/ti";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useEffect, useState } from "react";
import LocationImg from "../images/location-icon.png";
import { useLocation } from "react-router-dom";

export default function Footer() {
  const location = useLocation();

  const { ref, inView } = useInView({ triggerOnce: false, threshold: 0.1 });
  const [animationKey, setAnimationKey] = useState(0);

  useEffect(() => {
    if (inView) {
      setAnimationKey((prevKey) => prevKey + 1);
    }
  }, [inView]);
  const [enableAnimation, setEnableAnimation] = useState(true);

useEffect(() => {
  if (window.innerWidth < 768) {
    setEnableAnimation(false);
  } else {
    setEnableAnimation(true);
  }
}, []);


  const getTitle = () => {
    switch (location.pathname) {
      case "/website-development":
        return (
          <>
            <span className="sm:text-xl text-lg  lg:flex-[1.6]  lg:text-4xl font-bold text-black">
              Hire the Best
              <span className="text-webOranage font-bold mx-2">Web</span>
              Development Team <br></br>
              <p className="text-black sm:block hidden  text-sm mt-2">
                Unlock your business potential with a powerful website. Get in
                touch with us today!{" "}
              </p>
            </span>

            <div className="lg:flex-[0.6] ">
              <a
                href="/contact-us"
                className="lg:mt-0 mt-3 px-5  py-2 bg-[#055594] w-fit  text-white rounded-lg flex items-center ml-auto"
              >
                Get Started{" "}
              </a>
            </div>
          </>
        );
      case "/mobile-app-development":
        return (
          <>
            <span className="sm:text-xl text-lg  lg:flex-[1.6]  lg:text-3xl font-bold text-black">
              Hire the Best
              <span className="text-webOranage font-bold mx-2">Android </span>
              Development Team <br></br>
              <p className="text-black sm:block hidden  text-sm mt-2">
                Build high-performance Android apps with our experienced team.
              </p>
            </span>

            <div className="lg:flex-[0.6] ">
              <a
                href="/contact-us"
                className="lg:mt-0 mt-3 px-5  py-2 bg-[#055594] w-fit  text-white rounded-lg flex items-center ml-auto"
              >
                Get Started{" "}
              </a>
            </div>
          </>
        );
      case "/uiux-designer":
        return (
          <>
            <span className="sm:text-2xl text-md  lg:flex-[2]   font-bold text-black">
              Ready to{" "}
              <span className="text-webOranage font-bold mx-2">improve</span>
              Development Team your user experience?
              <br></br>
              <p className="text-black sm:block hidden text-sm mt-2">
                Get in touch with us today for a free consultation!
              </p>
            </span>

            <div className="lg:flex-[0.5] ">
              <a
                href="/contact-us"
                className="lg:mt-0 mt-3 px-5  py-2 bg-[#055594] w-fit  text-white rounded-lg flex items-center ml-auto"
              >
                Get Started{" "}
              </a>
            </div>
          </>
        );
        case "/crm-development":
          return (
            <>
              <span className="sm:text-2xl text-[16px]  lg:flex-[2]   font-bold text-black">
              Empower  
                <span className="text-webOranage font-bold mx-2">your business</span>
                with a smart, scalable CRM system designed to drive growth.                <br></br>
                <p className="text-black sm:block hidden text-sm mt-2">
                Contact us at <b>info@binaryops.co</b> to schedule a demo .
                </p>
              </span>
  
              <div className="lg:flex-[0.5] ">
                <a
                  href="/contact-us"
                  className="lg:mt-0 mt-3 px-5  py-2 bg-[#055594] w-fit  text-white rounded-lg flex items-center ml-auto"
                >
                  Get Started Today
                </a>
              </div>
            </>
          );
        case "/custom-software-development":
        return (
          <>
            <span className="sm:text-2xl text-md  lg:flex-[2]   font-bold text-black">
            Ready to build a  <span className="text-webOranage font-bold mx-2">custom software solution</span>
            that transforms your business?
              <br></br>
              <p className="text-black sm:block hidden text-sm mt-2">
              Contact us today at info@binaryops.co to schedule a consultation!            </p>
            </span>

            <div className="lg:flex-[0.5] ">
              <a
                href="/contact-us"
                className="lg:mt-0 mt-3 px-5  py-2 bg-[#055594] w-fit  text-white rounded-lg flex items-center ml-auto"
              >
                Get Started{" "}
              </a>
            </div>
          </>
        );
        case "/point-of-sale-development":
        return (
          <>
            <span className="sm:text-2xl text-md  lg:flex-[2]   font-bold text-black">
            Upgrade to a 
              <span className="text-webOranage font-bold mx-2">smarter,faster</span>
              and more efficient POS system.<br></br>
              <p className="text-black sm:block hidden text-sm mt-2">
              Contact us at info@binaryops.co to schedule a demo and take your business to the next level!          </p>
            </span>

            <div className="lg:flex-[0.5] ">
              <a
                href="/contact-us"
                className="lg:mt-0 mt-3 px-5  py-2 bg-[#055594] w-fit  text-white rounded-lg flex items-center ml-auto"
              >
               Get Started Today
              </a>
            </div>
          </>
        );
      case "/contact-us":
        return (
          <>
            <h2 className="sm:text-xl text-lg  lg:flex-[1.6]  lg:text-4xl font-bold text-black">
              We’re
              <span className="text-webOranage font-bold mx-2">
                Delivering the Best
              </span>
              Customer Experience{" "}
            </h2>

            <div className="lg:flex-[0.6]">
              <a
                href="tel:+441293730103"
                className="lg:mt-0 mt-3 px-5  py-2 bg-[#055594] w-fit  text-white rounded-lg flex items-center ml-auto"
              >
                <FaPhoneAlt className="mr-2" /> ( +44 ) 1293730103
              </a>
            </div>
          </>
        );
      default:
        return (
          <>
            <h2 className="sm:text-xl text-lg small:py-5 lg:flex-[1.6]  lg:text-4xl font-bold text-black">
              Let’s
              <span className="text-webOranage font-bold mx-2">
                Build something
              </span>
              exceptional
            </h2>

            <div className="lg:flex-[0.6] small:py-5">
              <a
                href="/contact-us"
                className="lg:mt-0 mt-3 px-5  py-2 bg-[#055594] w-fit  text-white rounded-lg flex items-center ml-auto"
              >
                Get in touch today!
              </a>
            </div>
          </>
        );
    }
  };

  return (
    <motion.footer
    ref={ref}
    key={animationKey}
    initial={enableAnimation ? { opacity: 0, y: 100 } : {}}
    animate={enableAnimation && inView ? { opacity: 1, y: 0 } : {}}
    transition={{ duration: 1, ease: "easeOut" }}
    className="bg-gradient-to-r from-[#094472] to-[#04599C] text-white relative mt-20"
  >
      <div className=" lg:px-10 px-5 lg:flex items-end absolute left-1/2 -translate-x-1/2 -top-16 bg-[#F6F6F6] small:w-[70vw] w-[90%] mx-auto rounded-3xl f lg:py-7 py-2 shadow-lg">
        {getTitle()}
      </div>

      {/* Main Footer Content */}
      <div className="max-w-[1280px] mx-auto md:px-10 px-5 md:py-10 py-5 mt-16">
        <div className="small:flex gap-5 border-b border-slate-200 pb-10">
          {/* Left Side - Logo & Description */}
          <div className="flex-[1.5]">
            <img
              src={require("../../common/images/footer-logo.png")}
              className="md:w-[284px] w-1/2 md:h-[66px] h-auto"
              alt="Footer Logo"
            />
            <div className="flex  ">
              <div className="para w-full small:mx-5 mx-0">
                <p className="text-sm mt-4 small:w-[90%] w-full  text-start text-gray-300  ">
                  At Binary Ops Pvt Ltd, our mission is to empower businesses
                  with innovative, high-quality software solutions that drive
                  growth and efficiency. We strive to deliver exceptional web,
                  mobile, and custom software development, backed by expert
                  UI/UX design, testing, and customer support. With a commitment
                  to excellence and cutting-edge technology, we help businesses
                  thrive in the digital era.
                </p>
              </div>
              <div className="border-line md:block hidden h-[250px] w-[1px] bg-slate-200 opacity-50"></div>
            </div>
          </div>

          {/* Middle - Information & Services */}
          <div className="grid grid-cols-2  gap-5 flex-[2]  small:mt-0 mt-4">
            <div className="small:ml-7">
              <span className="text-lg font-semibold text-white mb-3">
                Information
                <div className="underline py-2 mx-auto">
                  <img
                    alt="underline"
                    src={require("../../common/images/underline.png")}
                    className="w-[78px] h-[5px]"
                  />
                </div>
              </span>
              <div className="flex mt-4">
                <ul className=" space-y-2 w-full   ">
                  {[
                    { name: "Home", link: "/" },
                    { name: "Services", link: "/services" },
                    { name: "Contact Us", link: "/contact-us" },
                    { name: "About Us", link: "/about-us" },
                    { name: "Career", link: "/career" },
                    { name: "Blog", link: "/blogs" },
                  ].map((item, index) => (
                    <li key={index} className="group  md:mx-auto">
                      <a
                        href={item.link}
                        className="block transition md:text-[16px] small:leading-7 text-sm  duration-300 hover:text-white w-fit"
                      >
                        {item.name}
                        <span className="block h-[2px] w-0 bg-webOranage transition-all duration-300 group-hover:w-full"></span>
                      </a>
                    </li>
                  ))}
                </ul>
                <div className="border-line md:block hidden h-[250px] w-[1px] bg-slate-200 opacity-50"></div>
              </div>
            </div>
            <div className="">
              <div className="small:mx-7">
                <span className="text-lg   font-semibold text-white mb-3">
                  Services
                  <div className="underline  py-2 ">
                    <img
                      alt="underline"
                      src={require("../../common/images/underline.png")}
                      className="w-[78px] h-[5px]"
                    />
                  </div>
                </span>
              </div>
              <div className="flex mt-4 ">
                <ul className="space-y-2  w-full small:ml-7 ">
                  {[
                    {
                      name: "Android Development",
                      link: "/android-development",
                    },
                    { name: "UI/UX Design", link: "/uiux-designer" },

                    { name: "Web Development", link: "/website-development" },
                    { name: "Point OF Sales", link: "/point-of-sale-development" },
                    { name: " Custom Software Development", link: "/custom-software-development" },
                    { name: " CRM Development", link: "/crm-development" },

                  ].map((item, index) => (
                    <li key={index} className="group  ">
                      <a
                        href={item.link}
                        className="block transition md:text-[16px] small:leading-7 text-sm  duration-300 hover:text-white w-fit"
                      >
                        {item.name}
                        <span className="block h-[2px] w-0 bg-webOranage transition-all duration-300 group-hover:w-full"></span>
                      </a>
                    </li>
                  ))}
                </ul>
                <div className="border-line md:block hidden h-[250px] w-[1px] bg-slate-200 opacity-50"></div>
              </div>
            </div>
          </div>

          {/* Right Side - Social Links */}
          <div className="flex-1 small:ml-5 small:mt-0 mt-5">
            <span className="text-lg    font-semibold text-white mb-3">
              Contact US
              <div className="underline py-2 mx-auto">
                <img
                  alt="underline"
                  src={require("../../common/images/underline.png")}
                  className="w-[78px] h-[5px]"
                />
              </div>
            </span>
            <div className="flex space-x-4 mt-3">
              <a
                href="https://www.facebook.com/binaryops"
                className="p-2 bg-white text-[#043a70] rounded-full"
              >
                <FaFacebookF size={16} />
              </a>
              <a
                href="https://www.linkedin.com/company/binary-ops"
                className="p-2 bg-white text-[#043a70] rounded-full"
              >
                <FaLinkedinIn size={16} />
              </a>
              <a
                href="https://www.youtube.com/@binaryopspvtltd"
                className="p-2 bg-white text-[#043a70] rounded-full"
              >
                <TiSocialYoutube size={16} />
              </a>
            </div>
          </div>
        </div>

        {/* Address & Offices */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 flex-1  text-center md:text-left mt-10">
          {/* UK Office */}
          <div className=" flex">
            <div>
              <div className="flex items-center justify-center md:justify-start space-x-2">
                <img
                  src={LocationImg}
                  alt="location"
                  className="small:w-[26px] small:h-[31px] w-7"
                ></img>{" "}
                <h4 className="text-lg font-semibold">UK Office</h4>
              </div>
              <p className="text-sm text-gray-300 mt-2">
                Stanley House Kelvin Way Crawley, West Sussex, RH10 9SE, United
                Kingdom
              </p>
            </div>{" "}
            <div className="border-line md:block hidden h-[100px] w-[1px] bg-slate-200 opacity-50"></div>
          </div>

          {/* Islamabad Office */}
          <div className=" flex">
            <div className="w-full">
              <div className="flex items-center justify-center md:justify-start space-x-2">
                <img
                  src={LocationImg}
                  alt="location"
                  className="small:w-[26px] small:h-[31px] w-7"
                ></img>{" "}
                <h4 className="text-lg font-semibold">Islamabad Office</h4>
              </div>
              <p className="text-sm text-gray-300 mt-2">
                Islamabad Office: Office # G422-A, Bahria Safari Valley <br />
                Sector E Rawalpindi, Punjab, Pakistan{" "}
              </p>
              <div className="flex items-center justify-center md:justify-start space-x-2 mt-2">
                <FaPhoneAlt />
                <a href="tel:+441293730103" className="text-sm cursor-pointer">
                  ( +44 ) 1293730103
                </a>
              </div>
            </div>
            <div className="border-line md:block hidden h-[100px] w-[1px] bg-slate-200 opacity-50"></div>
          </div>

          {/* Peshawar Office */}
          <div>
            <div className="flex items-center justify-center md:justify-start space-x-2">
              <img
                src={LocationImg}
                alt="location"
                className="small:w-[26px] small:h-[31px] w-7"
              ></img>{" "}
              <h4 className="text-lg font-semibold">Peshawar Office</h4>
            </div>
            <p className="text-sm text-gray-300 mt-2">
              Office number12, 2nd floor Block C, Jawad Towers, Peshawar,
              Pakistan
            </p>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="text-center bg-[#054475] small:text-xl font-normal text-md py-3 text-white small:mt-10">
        © 2025 Binary Ops Pvt Ltd.{" "}
        <span className="text-webOranage font-medium">All Rights Reserved</span>
      </div>
    </motion.footer>
  );
}
